import React, { useState, useEffect } from "react";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";

import ListAlt from "@material-ui/icons/ListAlt";
import { getPreinstallChecklistItems } from "./checklistItems";

import config from "config.js";
import { Link } from "react-router-dom";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

import loadContent from "core-module/hoc/loadContent";
const importedStyle = dashboardStyle;
const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: { ...importedStyle.cardTitle, margin: "30px", padding: "20px" },
  cardIconTitle: importedStyle.cardIconTitle,
  stats: importedStyle.stats,
};
//import Contrac from "./AutoPaymentSummary.jsx";

const Checklist = (props) => {
  const [checklist, setChecklist] = useState({});
  const getList = props.getList;

  useEffect(() => {
    getList((oGet) => {
      setChecklist({
        shortform: oGet("shortform", "value"),
        hidedocuments: oGet("hidedocuments", "value"),
        contractstatus: oGet("contractstatus", "value"),
        papstatus: oGet("papstatus", "value"),
        documentstatus: oGet("documentstatus", "value"),
        packagestatus: oGet("packagestatus", "value"),
        additionalinfostatus: oGet("additionalinfostatus", "value"),
        schedulestatus: oGet("schedulestatus", "value"),
      });
    });
  }, [getList]);

  function colorMe(status) {
    if (status === "C") {
      return "success";
    }
    if (status === "P") {
      return "warning";
    }
    return "danger";
  }

  function statusText(status) {
    if (status === "C") {
      return " (complete)";
    }
    if (status === "P") {
      return " (pending)";
    }
    return " (missing)";
  }

  function condText(status, text) {
    if (status === "C") {
      return "Done!";
    }
    if (status === "P") {
      return "Pending review. Please check later.";
    }
    return text;
  }

  const { classes } = props;
  const checklistItems = getPreinstallChecklistItems(checklist);

  return (
    <GridContainer justify="center">
      <GridItem xs={12} md={10}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <ListAlt />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Pre-Install Checklist</h4>
          </CardHeader>
          <CardBody>
            <h4 className={classes.cardTitle}>
              Please follow these steps to prepare for an install.
              {isMobile() ? null : (
                <font color="red">
                  <br />
                  <br />
                  We prefer you use your mobile phone to sign the contract.
                </font>
              )}
            </h4>
          </CardBody>
        </Card>
      </GridItem>
      {checklistItems.map((item) => {
        const Icon = item.icon;
        return (
          <GridItem key={item.title} xs={12} md={10}>
            <Link to={config.MYACCOUNT.APP_PATH + "/user" + item.path}>
              <Card>
                <CardHeader color={colorMe(item.status)} icon>
                  <CardIcon color={colorMe(item.status)}>
                    <Icon />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    {item.title}
                    {statusText(item.status)}
                  </h4>
                </CardHeader>
                <CardBody>
                  <h4 className={classes.cardTitle}>
                    {condText(item.status, item.text)}
                  </h4>
                </CardBody>
              </Card>
            </Link>
          </GridItem>
        );
      })}
    </GridContainer>
  );
};

function isMobile() {
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

export default withStyles(styles)(
  loadContent("user.session/preinstallchecklist", Checklist)
);
